<template>
  <div>
    <Row style="margin-bottom:10px;">
       <div>
            <span> Quantities:  </span>
            <Input number
                  v-model="quantityInput"
                  placeholder='Input Quantity'
                  style="width: 100px"
                  @on-blur="setQuantity"
                  @on-enter="setQuantity" />
            <span v-if="quantities && quantities.length > 0">&nbsp;|&nbsp;</span>
            <Tag type="dot"
              color="primary"
              v-if="quantities"
              v-for="item in quantities"
              :key="'quantity' + item"
              :name="item"
              closable
              @on-close="removeQuantity">{{ item }}</Tag>
        </div>
    </Row>
    <Row :gutter="10">
      <Col span="8" v-if="summaries" v-for="summary in summaries" :key="'summary' + summary.quantity">
        <Card :title="'PCB Tentative summary (' + summary.quantity + ')'" icon="ios-options" :padding="0" shadow>
            <CellGroup class="pricingemphasis">
              <Cell label="Impedance Test">
                <i-switch width="40px" v-model="summary.impedanceTest" size="small"  @on-change="generateSummaries">
                    <span slot="open">Yes</span>
                    <span slot="close">No</span>
                </i-switch>
             </Cell>
              <Cell label="Service Fee">
                <InputNumber v-model="summary.serviceFee" :active-change="false" size="small" @on-change="generateSummaryItem(summary.quantity, summary)"></InputNumber> {{currency}}
              </Cell>
              <Cell label="Lead Time">
                <InputNumber size="small" :min="5" :precision="0" v-model="summary.leadTime" placeholder="Lead Time" :active-change="false" @on-change="generateSummaryItem(summary.quantity, summary)"></InputNumber>
              </Cell>
              <Cell label="Proofing fee">
                  {{summary.profingFee}}  {{currency}}
              </Cell>
               <Cell label="Puzzle fee">
                  {{summary.puzzleFee}}  {{currency}}
              </Cell>
              <Cell label="Total">
                  {{summary.subTotal}}  {{currency}}
              </Cell>
              <Cell v-for="(urgencyFee, urgencyDay) in summary.urgencyFees" :key="'urgencyDay' + urgencyDay"  :label="'Total(urgency ' + urgencyDay + ' day)'">
                  {{urgencyFee}} {{currency}}
              </Cell>
              <Cell label="Urgency">
                    {{summary.urgency}} Days
              </Cell>
            </CellGroup>
        </Card>
        <div style="margin-top:10px"></div>

        <Card :title="'Cost (' + summary.quantity + ')'" icon="ios-options" :padding="0" shadow>
          <CellGroup class="pricingemphasis">
            <Cell label="Cost Percentage">
              <InputNumber size="small" :max="100" v-model="summary.percentageMargin" @on-change="generateSummaries" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" :active-change="false"></InputNumber>
            </Cell>
            <Cell label="Percentage Cost">
                {{summary.percentageCost}}  {{currency}}
            </Cell>
            <Cell label="Shipment Cost">
                {{summary.shipmentCost}}  {{currency}}
            </Cell>
            <Cell label="Total Cost">
                {{summary.totalCost}}  {{currency}}
            </Cell>
          </CellGroup>
        </Card>
        <div style="margin-top:10px"></div>
        <Collapse simple>
          <Panel>
            <strong> Attr. ({{summary.quantity}})</strong>
            <div slot="content">
                <CellGroup>
                  <Cell label="Width">
                      {{summary.width}}
                  </Cell>
                  <Cell label="Height">
                      {{summary.height}}
                  </Cell>
                  <Cell label="Total dimension">
                      {{summary.totalDimensionM2}} M<sup>2</sup>
                  </Cell>
                  <Cell v-for="(unitPrice, layer) in summary.layerUnitPrices" :key="'layerUnitPrices' + layer" :label="layer + ' Layers Unit Price'">
                      {{unitPrice}} {{currency}}
                  </Cell>
                  <Cell label="Unit price">
                      {{summary.unitPrice}} {{currency}}
                  </Cell>
                  <Cell label="PCB Material Cost">
                      {{summary.pcbMaterialCost}} Times
                  </Cell>
                  <Cell label="Min. trace/space (M)">
                      {{summary.mintracespaceMultiplier}} Times
                  </Cell>
                  <Cell label="Construction Fee (CNY)">
                      {{summary.constructionFee}} CNY
                  </Cell>
                  <Cell label="Test Stand Fee (CNY)">
                      {{summary.testStandFee}} CNY
                  </Cell>
                  <Cell v-for="(standleadTime, layer) in summary.layerStandleadTime" :key="'standleadTime' + layer" :label="layer + ' Layers Stand Lead Time'">
                      {{standleadTime}} Days
                  </Cell>
                  <Cell label="Standard Lead Time">
                      {{summary.standleadTime}} Days
                  </Cell>
                  <Cell label="Urgency">
                      {{summary.urgency}} Days
                  </Cell>
                  <Cell label="Urgency Fee">
                      <div v-if="summary.urgency <= 3">
                        {{summary.urgencyfeeMultiplier}} Times
                      </div>
                      <div v-else>
                          <Alert type="warning" show-icon>Urgency days more than 3</Alert>
                      </div>
                  </Cell>
                  <Cell label="Impedance Test">
                      {{summary.impedanceTestMultiplier}} Times
                  </Cell>
                </CellGroup>
            </div>
          </Panel>
        </Collapse>
      </Col>
    </Row>
  </div>
</template>

<script>
import Config from '../config/calculation-config.js'
import { mapActions } from 'vuex'
export default {
  name: 'PcbTentativeSummary',
  data () {
    return {
      currency: 'CNY',
      summaries: {},
      quantityInput: null,
      quantities: [],
      quantitySet: false
    }
  },
  computed: {
    pcbSpec: {
      get () {
        if (this.$store.state.pcb.pcbSpecification) {
          return this.convertCamelCase(this.$store.state.pcb.pcbSpecification)
        } else {
          return null
        }
      }
    }
  },
  watch: {
    'pcbSpec': {
      handler: function () {
        this.generateSummaries()
      },
      deep: true
    },
    'quantities': {
      handler: function () {
        this.generateSummaries()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'updatePcbSummary',
      'createPcbSummary',
      'deletePcbSummary'
    ]),
    saveSummaries(pcbSpecificationId) {
      _.forEach(this.summaries, (summary) => {
        var data = {
          'id': summary.id,
          'pcb_specification_id': pcbSpecificationId,
          'impedance_test': summary.impedanceTest,
          'percentage_margin': summary.percentageMargin,
          'cost_percentage': summary.costPercentage,
          'lead_time': summary.leadTime,
          'currency': this.currency,
          'volume': summary.quantity,
          'total_cost': summary.totalCost,
          'shipment_cost': summary.shipmentCost,
          'service_fee': summary.serviceFee,
          'percentage_cost': summary.percentageCost,
          'urgency_total': summary.urgencyTotal,
          'sub_total': summary.subTotal
        }
        if (summary.id) {
          this.updatePcbSummary(data).then(res => {
            var data = this.convertCamelCase(res)
            this.summaries[res.volume] = this.generateSummaryItem(res.volume, data)
          })
        } else {
          this.createPcbSummary(data).then(res => {
            var data = this.convertCamelCase(res)
            this.summaries[res.volume] = this.generateSummaryItem(res.volume, data)
          })
        }
      })
    },
    onImpedanceTestChange(quantity, summary, value) {
      this.generateSummaryItem(quantity, summary)
    },
    setQuantity (event) {
      if (this._.toNumber(this.quantityInput)) {
        const newList = this._.union([this.quantityInput], this.quantities).sort(function (a, b) {
          return a - b
        })
        this.quantities = newList
        this.quantityInput = null
      }
    },
    // 移除某个batch数量
    removeQuantity (event, value) {
      const index = this.quantities.indexOf(value)
      this.quantities.splice(index, 1).sort(function (a, b) {
        return a - b
      })
      const pcbSummaryToDelete = _.get(this.summaries, value)
      if (pcbSummaryToDelete) {
        this.deletePcbSummary(pcbSummaryToDelete.id).then(res => {
          this.$Message.success(`Volume of ${value} is removed!`)
        })
      }
    },
    convertCamelCase: function (data) {
      var newData = this._.mapKeys(data, (value, key) => {
        return this._.camelCase(key)
      })
      return newData
    },
    convertSnakeCase: function (data) {
      var newData = this._.mapKeys(data, (value, key) => {
        return this._.snakeCase(key)
      })
      return newData
    },
    getRangeConfigValue (configs, compareTo) {
      const find = this._.find(configs, function (item) {
        if (item.max) {
          return compareTo > item.min && compareTo <= item.max
        } else {
          return compareTo > item.min
        }
      })
      if (find) {
        return find.value
      } else {
        return null
      }
    },
    getAreaRangeValue (configTSF, checkValidity) {
      const find = this._.find(configTSF, function (item) {
        if (item.max) {
          return checkValidity > item.min && checkValidity <= item.max
        } else {
          return checkValidity > item.min
        }
      })
      if (find) {
        return find.value
      } else {
        return null
      }
    },
    generateSummaries () {
      if (this.pcbSpec.volumes && this.pcbSpec.volumes.length > 0 && !this.quantitySet) {
        this.quantities = this.pcbSpec.volumes
        this.quantitySet = true
      }

      // Inital summaries
      if (this.pcbSpec.summaries) {
        _.forEach(this.pcbSpec.summaries, (summary) => {
          var quantity = summary.volume
          if (!this.summaries[quantity]) {
            this.summaries[quantity] = this.convertCamelCase(summary)
          }
        })
      }

      // Inital quanities for summary
      if (this.quantities && this.quantities.length > 0) {
        _.forEach(this.quantities, (quantity) => {
          if (!this.summaries[quantity]) {
            var data = {}
            this.summaries[quantity] = this.convertCamelCase(data)
          }
        })
      }
      this.summaries = this._.pick(this.summaries, this.quantities)

      _.forEach(this.summaries, (summary, quantity) => {
        this.generateSummaryItem(quantity, summary)
      })

      return this.summaries
    },
    generateSummaryItem (quantity, summary) {
      if (this.pcbSpec == null) {
        return false
      }
      var dimensionCalculated = this.pcbSpec.height * this.pcbSpec.width * quantity
      var dimension = this._.round(dimensionCalculated, 2)
      var percentageMargin = summary.percentageMargin ? summary.percentageMargin : 20
      var leadTime = summary.leadTime ? summary.leadTime : 10
      var impedanceTestText = summary.impedanceTest ? 'Yes' : 'No'
      var width = this.pcbSpec.width ? this._.round(this.pcbSpec.width, 4) + ' ' + this.pcbSpec.measurementUnit : ''
      var height = this.pcbSpec.height ? this._.round(this.pcbSpec.height, 4) + ' ' + this.pcbSpec.measurementUnit : ''
      var finishedThickness = this._.round(this.pcbSpec.thickness, 4) + ' ' + this.pcbSpec.measurementUnit
      var minHoleSize = this._.round(this.pcbSpec.minHoleSizes, 4) + ' ' + this.pcbSpec.measurementUnit
      var totalDimensionCM2 = 0
      var totalDimensionM2 = 0
      var puzzleFee = 0
      var profingFee = 0
      var unitPrice = 0
      var configs = 0
      var configTSF = 0
      var pcbMaterialCost = 0
      var mintracespaceMultiplier = 0
      var constructionFee = 0
      var testStandFee = 0
      var standleadTime = 0
      var standleadTimeCalculated
      var urgency = 0
      var urgencyfeeMultiplier = 0
      var impedanceTestMultiplier = 0
      var immersionFee = Config.immersionFee
      var subTotal = 0
      var urgencyTotal = 0
      var percentageCost = 0
      var totalCost = 0
      var shipmentCost = 0
      var serviceFee = summary.serviceFee ? this._.toNumber(summary.serviceFee) : 0

      // CONVERT TOTAL DIMENSIONS OF PCB INTO SQUARE CENTIMETRES
      if (this.pcbSpec.measurementUnit === 'mm') {
        totalDimensionCM2 = dimensionCalculated * 0.01
      } else if (this.pcbSpec.measurementUnit === 'inches') {
        totalDimensionCM2 = dimensionCalculated * 6.4516
      } else if (this.pcbSpec.measurementUnit === 'cm') {
        totalDimensionCM2 = dimensionCalculated
      }

      // CONVERT TOTAL DIMENSIONS OF PCB INTO SQUARE METRES
      if (this.pcbSpec.measurementUnit === 'mm') {
        totalDimensionM2 = dimensionCalculated * 0.000001
      } else if (this.pcbSpec.measurementUnit === 'inches') {
        totalDimensionM2 = dimensionCalculated * 0.00064516
      } else if (this.pcbSpec.measurementUnit === 'cm') {
        totalDimensionM2 = dimensionCalculated * 0.0001
      }

      totalDimensionM2 = this._.round(totalDimensionM2, 4)

      // IF TOTAL DIMENSION < 1 M2, WILL HAVE PROFING FEE
      if (totalDimensionM2 < 1) {
        profingFee = Config.profingFee
      }
      // PCB UNIT PRICE PER PIECE (DEPENDENT ON THE NUMBER OF LAYERS AND TOTAL DIMENSION OF THE PCB)
      configs = Config.totalDimensionConfig[this.pcbSpec.layers]
      unitPrice = this.getRangeConfigValue(configs, totalDimensionM2)
      var layerUnitPrices = {}
      this._.forEach(Config.totalDimensionConfig, (config, layerSize) => {
        layerUnitPrices[layerSize] = this.getRangeConfigValue(config, totalDimensionM2)
      })

      // PCB MATERIAL COST MULTIPLIER
      pcbMaterialCost = Config.pcbMaterialCostConfig[this.pcbSpec.materials]

      // MINIMUM TRACE/SPACE COST MULTIPLIER
      if ((4 - this.pcbSpec.minTraceSpace) > 0) {
        mintracespaceMultiplier = 1 + ((4 - this.pcbSpec.minTraceSpace) * 10 * 0.03)
      } else {
        mintracespaceMultiplier = 1
      }

      // PCB CONSTRUCTION FEE (DEPENDENT ON THE NUMBER OF LAYERS OF THE PCB)
      constructionFee = Config.constructionFeeConfig[this.pcbSpec.layers]

      if (constructionFee) {
        puzzleFee = constructionFee / 2 * (this.pcbSpec.puzzle - 1)
      }

      // TEST STAND FEE (DEPENDENT ON THE NUMBER OF LAYERS OF THE PCB AND WHETHER THE TOTAL DIMENSION OF PCB IS GREATER THAN OR EQUAL TO 3m^2)
      configTSF = Config.testStandFeeConfig[this.pcbSpec.layers]
      testStandFee = this.getAreaRangeValue(configTSF, totalDimensionM2)
      if (!testStandFee) {
        testStandFee = 0
      }
      // STANDARD LEAD TIME OF PCB MANUFACTURE (DEPENDENT ON THE NUMBER OF LAYERS AND TOTAL DIMENSION OF PCB)
      configs = Config.standardleadTimeConfig[this.pcbSpec.layers]
      standleadTimeCalculated = this.getRangeConfigValue(configs, totalDimensionM2)
      standleadTime = standleadTimeCalculated + ' Days'
      var layerStandleadTime = {}
      this._.forEach(Config.standardleadTimeConfig, (config, layerSize) => {
        layerStandleadTime[layerSize] = this.getRangeConfigValue(config, totalDimensionM2)
      })

      // IMPEDANCE TEST MULTIPLIER
      impedanceTestMultiplier = Config.impedanceTestMultiplierConfig[impedanceTestText]

      // SUB-TOTAL PRICE
      subTotal = this._.round((
        (totalDimensionCM2 * (unitPrice + immersionFee) * pcbMaterialCost * mintracespaceMultiplier * impedanceTestMultiplier) + (constructionFee + testStandFee + serviceFee + profingFee + puzzleFee)
      ), 2)

      // URGENCY OF PCB
      if ((leadTime < standleadTimeCalculated)) {
        urgency = (standleadTimeCalculated - leadTime)
      } else {
        urgency = 0
      }

      if (urgency === 0) {
        urgencyfeeMultiplier = 1
      } else {
        urgencyfeeMultiplier = Config.urgencyConfig[urgency] ? Config.urgencyConfig[urgency] : null
      }
      var urgencyFees = {}
      this._.forEach(Config.urgencyConfig, (multiplier, urgencyDay) => {
        urgencyFees[urgencyDay] = this._.round(multiplier * subTotal, 2)
      })

      // TOTAL WITH URGENCY FEE
      urgencyTotal = urgencyfeeMultiplier ? this._.round(subTotal * urgencyfeeMultiplier, 2) : 0

      // OVERALL PERCENTAGE, SHIPMENT AND TOTAL COST
      percentageCost = this._.round(subTotal * (1 + (percentageMargin / 100)), 2)
      shipmentCost = this._.round((((totalDimensionCM2 / 1000) * 46) + 175), 2)
      totalCost = this._.round((percentageCost + shipmentCost), 2)

      summary['id'] = summary.id ? summary.id : null
      summary['measurementUnit'] = this.pcbSpec.measurementUnit
      summary['quantity'] = quantity
      summary['layers'] = this.pcbSpec.layers
      summary['leadTime'] = leadTime
      summary['standleadTime'] = standleadTime
      summary['urgency'] = urgency
      summary['materials'] = this.pcbSpec.materials
      summary['minHoleSize'] = minHoleSize
      summary['minTraceSpace'] = this.pcbSpec.minTraceSpace
      summary['impedanceTest'] = summary.impedanceTest
      summary['impedanceTestText'] = impedanceTestText
      summary['finishedThickness'] = finishedThickness
      summary['copperWeight'] = this.pcbSpec.copperWeight
      summary['solderMask'] = this.pcbSpec.solderMask
      summary['surfaceFinish'] = this.pcbSpec.surfaceFinish
      summary['legendColor'] = this.pcbSpec.legendColor
      // Price summaries
      summary['profingFee'] = profingFee
      summary['puzzleFee'] = puzzleFee
      summary['percentageMargin'] = percentageMargin
      summary['subTotal'] = subTotal
      summary['urgencyTotal'] = urgencyTotal
      summary['serviceFee'] = serviceFee
      summary['percentageCost'] = percentageCost
      summary['shipmentCost'] = shipmentCost
      summary['totalCost'] = totalCost
      // Calculation attributes
      summary['width'] = width
      summary['height'] = height
      summary['dimension'] = dimension
      summary['totalDimensionCM2'] = totalDimensionCM2
      summary['totalDimensionM2'] = totalDimensionM2
      summary['pcbMaterialCost'] = pcbMaterialCost
      summary['mintracespaceMultiplier'] = mintracespaceMultiplier
      summary['layerUnitPrices'] = layerUnitPrices
      summary['layerStandleadTime'] = layerStandleadTime
      summary['unitPrice'] = unitPrice
      summary['constructionFee'] = constructionFee
      summary['testStandFee'] = testStandFee
      summary['urgencyFees'] = urgencyFees
      summary['impedanceTestMultiplier'] = impedanceTestMultiplier
      summary['urgencyfeeMultiplier'] = urgencyfeeMultiplier
      return summary
    }
  }
}
</script>

<style lang="less">
.pricingemphasis {
  font-weight: normal;
}
</style>
